import * as undoActions from 'owa-mail-undo';
import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
/**
 * show notification on move or archive succeeded
 * @param numberOfItems acted on for the delete action
 * @param destinationFolderName for the move action
 * @param isArchive whether this is an archive action
 */
export default function showNotificationOnMoveOrArchiveSucceeded(numberOfItems, destinationFolderName, isArchive) {
    if (!isMailFeatureEnabled('tri-notificationBar')) {
        return;
    }
    var notificationText = numberOfItems === 1
        ? format(strings.moveItemSucceededNotification, destinationFolderName)
        : format(strings.moveItemsSucceededNotification, numberOfItems, destinationFolderName);
    if (isArchive) {
        notificationText =
            numberOfItems === 1
                ? strings.archiveItemSucceededNotification
                : format(strings.archiveItemsSucceededNotification, numberOfItems);
    }
    lazyShowNotification.importAndExecute('moveOrArchiveSucceededNotification', notificationText, {
        icon: isArchive ? "Archive" /* Archive */ : "FabricMovetoFolder" /* FabricMovetoFolder */,
        primaryActionText: strings.undoAction,
        notificationCallback: function (reason) {
            if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                undoActions.lazyUndo.importAndExecute('NotificationBar');
            }
        },
    });
}
//# sourceMappingURL=showNotificationOnMoveOrArchiveSucceeded.js.map